import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-head-of-department',
    templateUrl: './head-of-department.component.html',
    styleUrls: ['./head-of-department.component.scss']
})
export class HeadOfDepartmentComponent implements OnInit {
    src: string = '/assets/pdf/Head of Department.pdf';
    title: string = 'Head of Department';

    constructor() { }

    ngOnInit(): void {
    }

}
